<template>
  <b-card class="card-form shadow p-1 py-2 mx-0" no-body>
    <div class="row">
      <input type="hidden" name="id" id="id" :value="variableData.id" />
      <div class="col-sm-12 col-xs-12 col-md-12 col-lg-6 col-xl-6 mt-2">
        <InputText
          id="label"
          name="label"
          label="Pregunta/Etiqueta"
          autocomplete="label"
          :autofocus="true"
          validationMode="aggressive"
          validate="max:250|required"
          placeholder="Escriba la etiqueta"
          :value.sync="variableData.label"
        />
      </div>
      <div class="col-sm-12 col-xs-12 col-md-12 col-lg-6 col-xl-6 mt-2">
        <InputText
          id="description"
          name="description"
          label="Descripción"
          autocomplete="description"
          validationMode="aggressive"
          validate="max:500|required"
          placeholder="Escriba una breve descripción"
          :value.sync="variableData.description"
        />
      </div>
      <div class="col-sm-12 col-xs-12 col-md-12 col-lg-6 col-xl-6 mt-2">
        <InputSelect
          id="dimension"
          validate="required"
          name="dimension"
          label="Dimensión"
          autocomplete="dimension"
          :options="dimension_options"
          placeholder="Seleccione una dimensión"
          :value.sync="variableData.dimension"
        />
      </div>
      <div
        class="col-sm-12 col-xs-12 col-md-12 col-lg-6 col-xl-6 mt-2 radio-group"
      >
        <InputRadio
          id="classification"
          validate="required"
          name="classification"
          label="Clasificación"
          autocomplete="classification"
          :options="classification_options"
          :value.sync="variableData.classification"
          :onchange="setFocus"
        />
      </div>
      <div class="col-sm-12 col-xs-12 col-md-12 col-lg-6 col-xl-6 mt-2">
        <div class="row">
          <InputText
            id="order"
            ref="order_field"
            name="order"
            label="Orden"
            autocomplete="order"
            type="number"
            :step="0.1"
            class="mx-0 px-0"
            :class="{ 'col-11': variableData.classification === '1', 'col-12': variableData.classification === '2'}"
            placeholder="Escriba el orden"
            validationMode="aggressive"
            :validate="
              parseInt(variableData.classification) === 1
                ? {
                    regex: /[\d]{1,7}([.]\d{1,3})?/,
                    required: true,
                    minmax: [0, 9999999],
                  }
                : {}
            "
            :disabled="parseInt(variableData.classification) === 2"
            :value.sync="variableData.order"
            helpText="* Solo aplica para clasificación Base"
          />
          <div class="col-1 pt-3">
            <b-button
              class="mx-0 px-0"
              v-if="parseInt(variableData.classification) === 1"
              :disabled="parseInt(variableData.classification) !== 1"
              v-b-modal.modal-variables
              variant="link"
              v-b-tooltip.hover="{
                variant: 'primary',
                placement: 'bottom',
                title: 'Consultar Variables Base',
              }"
            >
              <b-icon
                icon="question-circle-fill"
                variant="primary"
                font-scale="1.6"
              ></b-icon>
            </b-button>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-xs-12 col-md-12 col-lg-6 col-xl-6 mt-2">
        <InputSelect
          ref="state_field"
          id="state"
          validate="required"
          name="state"
          label="Estado"
          autocomplete="state"
          :options="state_options"
          placeholder="Seleccione un estado"
          :value.sync="variableData.state"
        />
      </div>
      <div class="col-sm-12 col-xs-12 col-md-12 col-lg-6 col-xl-6 mt-2">
        <InputSelect
          ref="private"
          id="private"
          name="privacy"
          label="Nivel de Privacidad"
          autocomplete="state"
          :options="privacy_options"
          placeholder="Seleccione nivel de privacidad"
          :value.sync="variableData.privacy"
        />
      </div>
    </div>
    <b-modal
      id="modal-variables"
      title="Listado de Variables Base Activas"
      hide-footer
      size="lg"
    >
      <BaseDatatable
        ref="table"
        :drfprovider="getVariablesData"
        :tableheaders="variablesTableFields"
      >
        <template v-slot:cell(order)="row">{{
          parseFloat(row.value)
        }}</template>
        <template v-slot:cell(label)="row">{{ row.value }}</template>
        <template v-slot:cell(type_name)="row"
          ><span class="h5"
            ><b-icon
              :icon="
                $store.state.variables.variableIcons.filter(
                  (icon) => icon.key === row.item.type
                )[0].value
              "
              class="mr-1"
              font-scale="0.8"
            ></b-icon
          ></span>
          {{ row.value }}</template
        >
        <template v-slot:cell(classification_name)="row">{{
          row.value
        }}</template>
      </BaseDatatable>
    </b-modal>
  </b-card>
</template>

<script>
import { variablesMethods } from '@state/helpers'
import BaseDatatable from '@components/base-datatable'
import InputText from '@components/form/InputText'
import InputSelect from '@components/form/InputSelect'
import InputRadio from '@components/form/InputRadio'

export default {
  components: {
    BaseDatatable,
    InputText,
    InputSelect,
    InputRadio,
  },
  props: {
    variableData: {
      type: Object,
      required: false,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      classification: null,
      dimension_options: [],
      privacy_options: [],
      state_options: [
        { value: 'A', text: 'Activo' },
        { value: 'I', text: 'Inactivo' },
      ],
      classification_options: [
        { value: '1', text: 'Base' },
        { value: '2', text: 'Extendida' },
      ],
      variablesTableFields: [
        { key: 'order', label: 'Orden', sortable: true },
        { key: 'label', label: 'Pregunta / Etiqueta', sortable: true },
        { key: 'type_name', label: 'Tipo de Variable', sortable: true },
      ],
    }
  },
  watch: {
    variableData: {
      deep: true,
      handler(newValue, oldValue) {
        if (parseInt(newValue.classification) === 2) {
          newValue.order = null
        }
      },
    },
  },
  mounted() {
    this.getDimensionsData()
    this.getPrivacyLevelsData()
  },
  methods: {
    ...variablesMethods,

    getDimensionsData() {
      const promise = this.getDimensions('?page_size=999')
      let _ = this
      return promise
        .then((data) => {
          data.results.forEach((opt) => {
            _.dimension_options.push({
              value: opt.url,
              text: `${opt.name}`,
            })
          })
          return data
        })
        .catch((error) => {
          console.log(
            'Se presento un error en la carga de las dimensiones.',
            error
          )
        })
    },
    getPrivacyLevelsData() {
      const promise = this.getPrivacyLevels('?page_size=999')
      let _ = this
      return promise
        .then((data) => {
          data.results.forEach((opt) => {
            _.privacy_options.push({
              value: opt.url,
              text: `${opt.name}`,
            })
          })
          return data
        })
        .catch((error) => {
          console.log(
            'Se presento un error en la carga de los niveles de privacidad.',
            error
          )
        })
    },
    getVariablesData(ctx) {
      const promise = this.getVariablesList({
        query: this.$table_params(ctx) + '&classification=1&state=A',
      })
      let _ = this
      return promise
        .then((data) => {
          return data
        })
        .catch((error) => {
          console.log(
            'Se presento un error en la carga de las variables.',
            error
          )
        })
    },
    setFocus(value) {
      if (parseInt(this.variableData.classification) === 1) {
        this.$refs['order_field'].$el.elements[0].focus()
      } else {
        this.$refs['state_field'].$el.elements[0].focus()
      }
    },
  },
}
</script>

<style lang="scss">
.clasification-group label {
  font-weight: normal !important;
}
</style>